import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    age: 47,
    location: 'Buenos Aires, Argentina',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces',
    text: 'Después de años de dar vueltas en la cama, finalmente encontré algo que funciona. El protocolo de 14 noches cambió mi vida. Ahora duermo toda la noche y me despierto descansada.',
    rating: 5
  }, {
    name: 'Carmen Rodríguez',
    age: 52,
    location: 'Ciudad de México, México',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=faces',
    text: 'Lo que más me gustó es que no son tips sueltos, es un sistema completo. El Plan 3:00am me salvó la vida. Ya no me despierto con ansiedad en la madrugada.',
    rating: 5
  }, {
    name: 'Sofía Martínez',
    age: 44,
    location: 'Bogotá, Colombia',
    image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&h=400&fit=crop&crop=faces',
    text: 'Soy mamá de tres y trabajo tiempo completo. Pensé que nunca volvería a dormir bien. Este protocolo es realista y sostenible. En dos semanas noté el cambio.',
    rating: 5
  }];
  return <div className="py-20 px-4 sm:px-6 bg-gradient-to-b from-cream-50 to-white" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-198">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-900 mb-4" data-id="element-199">
            Lo que dicen nuestras clientas
          </h2>
          <p className="text-lg text-navy-600" data-id="element-200">
            Mujeres reales que recuperaron su descanso
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-201">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-white rounded-2xl p-6 shadow-lg border border-cream-200 relative" data-id="element-202">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-amber-200" data-id="element-203" />

              <div className="flex items-center mb-4" data-id="element-204">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-amber-200 mr-4" data-id="element-205" />
                <div data-id="element-206">
                  <h3 className="font-bold text-navy-900" data-id="element-207">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-navy-600" data-id="element-208">
                    {testimonial.age} años
                  </p>
                  <p className="text-xs text-navy-500" data-id="element-209">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex mb-3" data-id="element-210">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-211" />)}
              </div>

              <p className="text-navy-700 text-sm leading-relaxed italic" data-id="element-212">
                "{testimonial.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}